import styled from 'styled-components'

export const Wrapper = styled.div``

export const OnBoardingHeader = styled.div`
  height: 250px;
  width: 100%;
  background: aqua;

  .header_img {
    height: 250px;
    width: 100%;
  }
`

export const OnBoardingBody = styled.div`
  padding: 40px 30px;
  .name_description {
    margin-bottom: 30px;

    .name {
      font-family: ${({ theme }) => theme.fontFamily.inter};
      font-style: normal;
      font-weight: 600;
      font-size: ${({ theme }) => theme.fontSize.xl};
      /* line-height: 48px; */
      margin: 0;
      padding-bottom: 7px;
      color: ${({ theme }) => theme.colors.black};
    }

    .description {
      color: ${({ theme }) => theme.colors.gray3};
      font-size: ${({ theme }) => theme.fontSize.x5};
      font-weight: 400;
      margin: 0;
      font-family: ${({ theme }) => theme.fontFamily.inter};
    }
  }
  .details {
    p {
      margin: 0;
      padding: 5px 0;
      color: ${({ theme }) => theme.colors.navyBlue2};
      font-family: ${({ theme }) => theme.fontFamily.inter};
      font-weight: 700;
      font-size: ${({ theme }) => theme.fontSize.x5};
      line-height: 19px;
    }

    span {
      /* color: ${({ theme }) => theme.colors.gray3}; */
    }
  }

  .btn_wrapper {
    margin-top: 50px;
  }
`
